/** Mensaje para la persona según el error de la API de geolocalización del navegador. */
export function geolocationErrorMessage(error) {
  if (!error) return 'No se pudo obtener tu ubicación.';
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return 'Permiso de ubicación denegado. Actívalo en el navegador o en Ajustes del sitio.';
    case error.POSITION_UNAVAILABLE:
      return 'Ubicación no disponible. Comprueba que el GPS o la red estén activos.';
    case error.TIMEOUT:
      return 'Tiempo agotado al pedir la ubicación. Inténtalo de nuevo al aire libre.';
    default:
      return 'No se pudo obtener tu ubicación.';
  }
}

/** La geolocalización solo funciona en HTTPS o en localhost. */
export function geolocationDisponible() {
  if (typeof navigator === 'undefined' || !navigator.geolocation) return false;
  return window.isSecureContext || window.location.hostname === 'localhost';
}
